const PromoCodeColumn = ({
    row,
}) => {
    return row.PromoCode ?? '';
};

export default PromoCodeColumn;
